<div class="bm--auth-form-box">
  <h1 class="common-section-title common-section-title--form">Create new password</h1>
  <bmcore-new-password-form></bmcore-new-password-form>
</div>
